module.exports = __webpack_public_path__ + "static/media/clean-drinking-water.8cd29dbb.jpeg";